import axios from '../axios/axios';
import {
  INSURANCE_DATA_REQUEST,
  INSURANCE_DATA_SUCCESS,
  INSURANCE_DATA_FAIL,
} from '../constants/exitingInsuranceConstants';

export const exitingInsuranceAction = () => async (dispatch) => {
  try {
    dispatch({ type: INSURANCE_DATA_REQUEST });
    const { data } = await axios.post('/rpiq-form-fetch', {
      section: 'f1v1s14',
      form_id: localStorage.getItem('formId'),
    });

    dispatch({
      type: INSURANCE_DATA_SUCCESS,
      payload: data,
    });
  } catch (error) {
    if (
      error?.response?.status === 401 ||
      error?.response?.detail === 'Not authenticated'
    ) {
      window.location.replace('/');
    }
    dispatch({
      type: INSURANCE_DATA_FAIL,
      payload: error,
    });
  }
};
